exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hidden {\n    visibility: hidden;\n}\n\n.shown {\n    visibility: visible;\n}\n", ""]);

// exports
